export const STOCK_NOTIFICATION_TYPE = {
  MAXIMUM_ALLOWED_LIMIT_REACHED: 'MAXIMUM_ALLOWED_LIMIT_REACHED',
  ONLY_LEFT: 'ONLY_LEFT',
  OUT_OF_STOCK: 'OUT_OF_STOCK',
  NOT_AVAILABLE: 'NOT_AVAILABLE',
  VOLUME_NOT_AVAILABLE: 'VOLUME_NOT_AVAILABLE',
  VOLUME_OUT_OF_STOCK: 'VOLUME_OUT_OF_STOCK',
  NONE: 'NONE'
};

export const AVAILABILITY_NOTIFICATION_TYPE = {
  NOT_AVAILABLE: 'NOT_AVAILABLE',
  VOLUME_NOT_AVAILABLE: 'VOLUME_NOT_AVAILABLE',
  NONE: 'NONE'
};

export const STOCK_NOTIFICATION_MESSAGE = {
  [STOCK_NOTIFICATION_TYPE.MAXIMUM_ALLOWED_LIMIT_REACHED]: 'cart.maximumQuantityMessage',
  [STOCK_NOTIFICATION_TYPE.ONLY_LEFT]: 'cart.onlyLeftMessage',
  [STOCK_NOTIFICATION_TYPE.OUT_OF_STOCK]: 'cart.productOutOfStockMessage',
  [STOCK_NOTIFICATION_TYPE.NOT_AVAILABLE]: 'cart.unavailableInCountry',
  [STOCK_NOTIFICATION_TYPE.VOLUME_NOT_AVAILABLE]: 'cart.volumeIsUnavailable',
  [STOCK_NOTIFICATION_TYPE.VOLUME_OUT_OF_STOCK]: 'cart.volumeIsOutOfStock'
};

export const AVAILABILITY_NOTIFICATION_MESSAGE = {
  [STOCK_NOTIFICATION_TYPE.NOT_AVAILABLE]: 'cart.unavailableInCountry',
  [STOCK_NOTIFICATION_TYPE.VOLUME_NOT_AVAILABLE]: 'cart.volumeIsUnavailable'
};

export const PROMOCODE_APPLYING_ERROR = {
  DOES_NOT_EXIST: 'CANNOT_FIND_PROMO_CODE',
  DOES_NOT_WORK_IN_COUNTRY: 'PROMO_CODE_IS_NOT_AVAILABLE_FOR_CUSTOMER_COUNTRY'
};
